module.exports = __webpack_public_path__ + "img/methods-wizard.cfe56616.png";